import { CommonModule, DatePipe, CurrencyPipe, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TooltipModule } from 'primeng/tooltip';

import { MiscModule } from '../Misc/misc.module';
import { CommonFormsModule } from '../Forms/forms.module';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { CommonBasicModule } from '../Basic/basic.module';

import { ChartTooltipDirective } from './directives/chart-tooltip.directive';

import { QuotaMessageComponent } from './components/QuotaMessage/quota-message.component';
import { ExportMenuComponent } from './components/ExportMenu/export-menu.component';
import { CardChartComponent } from './components/CardChart/card-chart.component';
import { TopTermsChartComponent } from './components/TopTermsChart/top-terms-chart.component';
import { DataListChartComponent } from './components/DataListChart/data-list-chart.component';
import { ChartGroupComponent } from './components/ChartGroup/chart-group.component';
import { ChartComponent } from './components/Chart/chart.component';
import { DistributionUsageChartComponent } from './components/DistributionUsageChart/distribution-usage-chart.component';
import { PostFeedCardShareableComponent } from './components/PostFeedCardShareable/post-feed-card-shareable.component';
import { TopPostsChartShareableComponent } from './components/TopPostsChartShareable/top-posts-chart-shareable.component';
import { TopMentionsChartShareableComponent } from './components/TopMentionsChartShareable/top-mentions-chart-shareable.component';
import {
    TopMentionsChartCardShareableComponent
} from './components/TopMentionsChartShareable/TopMentionsChartCardShareable/top-mentions-chart-card-shareable.component';
import { ReportsChartComponent } from './components/ReportsChart/reports-chart.component';
import { ReportsSeriesDataMergerService } from '../Reports/services/reports-series-data-merger.service';
import { ReportsSeriesDataGrouperService } from '../Reports/services/reports-series-data-grouper.service';
import { CanvasChartComponent } from './components/CanvasChart/canvas-chart.component';
import { TopEntitiesChartComponent } from './components/TopEntitiesChart/top-entities-chart.component';
import { TopEntitiesDrillDownChartComponent } from './components/TopEntitiesChart/top-entities-drill-down-chart.component';
import { CoverageMetricChartComponent } from './components/CoverageMetricChart/coverage-metric-chart.component';
import { RouterModule } from '@angular/router';
import { Am5ChartComponent } from './components/Am5Chart/am5-chart.component';
import { Am5ChartTooltipService } from './services/am5-chart-tooltip.service';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MiscModule,
        LocalizationModule,
        CommonFormsModule,
        TooltipModule,
        CommonBasicModule,
        RouterModule
    ],
    declarations: [
        ExportMenuComponent,
        ChartGroupComponent,
        DataListChartComponent,
        CardChartComponent,
        TopTermsChartComponent,
        ChartComponent,
        Am5ChartComponent,
        DistributionUsageChartComponent,
        QuotaMessageComponent,
        ChartTooltipDirective,
        PostFeedCardShareableComponent,
        TopPostsChartShareableComponent,
        TopMentionsChartShareableComponent,
        TopMentionsChartCardShareableComponent,
        ReportsChartComponent,
        CanvasChartComponent,
        TopEntitiesChartComponent,
        TopEntitiesDrillDownChartComponent,
        CoverageMetricChartComponent
    ],
    exports: [
        ExportMenuComponent,
        ChartGroupComponent,
        DataListChartComponent,
        CardChartComponent,
        TopTermsChartComponent,
        ChartComponent,
        Am5ChartComponent,
        DistributionUsageChartComponent,
        QuotaMessageComponent,
        ChartTooltipDirective,
        PostFeedCardShareableComponent,
        TopPostsChartShareableComponent,
        TopMentionsChartShareableComponent,
        TopMentionsChartCardShareableComponent,
        ReportsChartComponent,
        CanvasChartComponent,
        TopEntitiesChartComponent,
        TopEntitiesDrillDownChartComponent,
        CoverageMetricChartComponent
    ],
    providers: [
        CurrencyPipe,
        DecimalPipe,
        DatePipe,
        ReportsSeriesDataMergerService,
        ReportsSeriesDataGrouperService,
        Am5ChartTooltipService
    ]
})
export class ChartsModule {

}
